import { render, staticRenderFns } from "./index.vue?vue&type=template&id=36447ecc&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=36447ecc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../contracts/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36447ecc",
  null
  
)

export default component.exports